export const reCaptchaUrl = "https://www.google.com/recaptcha/enterprise.js";
